import { ArrowDown, ArrowUp, Equal } from "lucide-react";

const TONE = { better: "text-emerald-700", worse: "text-red-700" };
const WORD = { better: "improved", worse: "worse", same: "no change" };
const val = (v, unit) => (v == null ? "—" : `${v}${unit}`);
const deltaUnit = (u) => (u.startsWith(" of") ? "" : u.startsWith("%") ? "%" : u.replace("/10", ""));

function Change({ r }) {
  if (r.delta == null) return <span className="text-zinc-400">—</span>;
  const Icon = r.delta > 0 ? ArrowUp : r.delta < 0 ? ArrowDown : Equal;
  return (
    <span className={`inline-flex items-center gap-1 font-semibold ${TONE[r.trend] || "text-zinc-700"}`} data-testid={`diary-change-${r.key}-value`}>
      <Icon className="h-3.5 w-3.5" />{r.delta ? `${r.delta > 0 ? "+" : ""}${r.delta}${deltaUnit(r.unit)}` : ""} {WORD[r.trend] || ""}
    </span>
  );
}

/** "What changed" between two diaries — improvement colours only where a better direction is defined. */
export function DiaryChangeTable({ rows }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-zinc-200" data-testid="diary-change-table">
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 text-left text-2xs uppercase tracking-wide text-zinc-500">
          <tr><th className="px-3 py-2">What changed</th><th className="px-3 py-2">Earlier</th><th className="px-3 py-2">Later</th><th className="px-3 py-2">Change</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key} className="border-t border-zinc-100" data-testid={`diary-change-${r.key}`}>
              <td className="px-3 py-2 text-zinc-900">{r.label}</td>
              <td className="px-3 py-2 font-mono-num">{val(r.a, r.unit)}</td>
              <td className="px-3 py-2 font-mono-num">{val(r.b, r.unit)}</td>
              <td className="px-3 py-2"><Change r={r} /></td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="border-t border-zinc-100 px-3 py-2 text-xs text-zinc-500">Averages only use answered questions — blanks are never counted as 0.</p>
    </div>
  );
}
